import PetType from '../../../../constants/petType';

export function getPetsSummary(applicants) {
  let petsSummary = {
    cats: 0,
    largeDogs: 0,
    mediumDogs: 0,
    other: 0,
    smallDogs: 0,
  };

  if (applicants && applicants.length > 0) {
    const applicantsPets = applicants.map((applicant) => applicant.answers.pets);

    applicantsPets.forEach((applicantPets) => {
      if (applicantPets) {
        Object.keys(applicantPets).forEach((type) => {
          if (applicantPets[type] > petsSummary[type]) {
            petsSummary[type] = applicantPets[type];
          }
        }, this);
      }
    }, this);

    const displayOrder = ['smallDogs', 'mediumDogs', 'largeDogs', 'cats', 'other'];
    const summaryString = displayOrder.reduce((displayString, type) => {
      if (petsSummary[type] > 0) {
        const pluralChar = petsSummary[type] > 1 ? 's' : '';
        return (
          displayString + `${petsSummary[type]} ${PetType[type].display}${pluralChar}${PetType[type].weightdisplay}, `
        );
      }
      return displayString;
    }, '');

    if (summaryString.length > 1) {
      return summaryString.slice(0, -2);
    }

    return 'None';
  }

  return 'None';
}
